import React from "react";

const defaultConfiguration: any = null;
const getConfiguration = async (showroomId: string) => {
  const response = await fetch(
    `${process.env.REACT_APP_CDN_SERVER}/${showroomId}/configuration.json`,
  );
  if (response.status !== 200) {
    return {};
  }
  const data = await response.json();
  return data;
};

export const ConfigurationStore = React.createContext(defaultConfiguration);

const Configuration: React.FC = ({ children }): JSX.Element | null => {
  const [configuration, setConfigurarion] = React.useState(null);

  const rootElement = document.getElementById("carbando-root");

  const showroomId = rootElement
    ? rootElement.getAttribute("data-showroom-id") ||
      process.env.REACT_APP_SHOP_ID
    : process.env.REACT_APP_SHOP_ID;

  const basename = rootElement
    ? rootElement.getAttribute("data-basename") || undefined
    : undefined;

  React.useEffect(() => {
    const loadConfiguration = async () => {
      const data = await getConfiguration(showroomId || "");
      setConfigurarion({ ...data, showroomId, basename });
    };

    loadConfiguration();
  }, [basename, showroomId]);

  if (!configuration) return null;

  return (
    <ConfigurationStore.Provider value={configuration}>
      {children}
    </ConfigurationStore.Provider>
  );
};

export default Configuration;
